<template>

	<div class="candidate-search">

		<div class="candidate-search__side">

			<filters></filters>

			<div class="cta cta--no-media cta--has-text bg-yellow bg-light" data-el-query="400,700,1000,1200,1400" data-min-width="400">

				<div class="cta__content-container">

					<div class="cta__media"></div>

					<div class="cta__content">

						<h4 class="heading">Are you a candidate?</h4>

						<p>Upload your resume here in seconds.</p>

						<a class="btn btn--icon bg-purple bg-dark" href="/register-cv"><span class="btn__text">Upload CV</span><!--?xml version="1.0" encoding="UTF-8"?-->
							<svg width="19px" height="15px" viewBox="0 0 19 15" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" class="icon">
								<title>icon/arrow/dark</title>
								<g id="icon/arrow/dark" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
									<g id="icon/arrow-right" class="icon__fill" fill-rule="nonzero">
										<path d="M10.0742697,14.52 C10.3189888,13.8470225 11.0531461,11.7873034 11.3998315,10.9511798 C9.97230337,10.6044944 6.07719101,9.52365169 3.69117978,8.97303371 L3.69117978,8.78949438 C4.99634831,8.8302809 7.81061798,8.91185393 9.89073034,8.91185393 C12.3583146,8.91185393 15.8251685,8.97303371 18.0276404,9.05460674 C17.9926806,8.72248796 17.9876863,7.98583352 17.9869728,7.48676352 L17.9869728,7.02568562 C17.9876863,6.51377322 17.9926806,5.77711878 18.0276404,5.445 C15.8251685,5.52657303 12.3583146,5.58775281 9.89073034,5.58775281 C7.81061798,5.58775281 4.99634831,5.66932584 3.69117978,5.71011236 L3.69117978,5.52657303 C6.07719101,4.99634831 9.97230337,3.91550562 11.3998315,3.56882022 C11.0531461,2.75308989 10.3189888,0.672977528 10.0742697,-1.24344979e-14 C7.7494382,1.46831461 1.83539326,4.79241573 -1.20792265e-13,5.56735955 C-1.20792265e-13,5.89365169 0.0203932584,6.7705618 0.0203932584,7.26 C0.0203932584,7.76983146 -1.20792265e-13,8.62634831 -1.20792265e-13,8.95264045 C1.85578652,9.72758427 7.7494382,13.0516854 10.0742697,14.52 Z" id="←" transform="translate(9.013820, 7.260000) scale(-1, 1) translate(-9.013820, -7.260000) "></path>
									</g>
								</g>
							</svg>
						</a>

					</div>

				</div>

			</div>

			<div class="cta cta--no-media cta--has-text bg-purple bg-dark" data-el-query="400,700,1000,1200,1400" data-min-width="400">

				<div class="cta__content-container">

					<div class="cta__media"></div>

					<div class="cta__content">

						<h4 class="heading">Refer a friend</h4>

						<p>Introduce a friend to Moxie and get a referral bonus</p>

						<a class="btn btn--icon bg-yellow bg-light" href="/refer-a-friend" rel="noopener" target="_blank"><span class="btn__text">Find out more</span><!--?xml version="1.0" encoding="UTF-8"?-->
							<svg width="19px" height="15px" viewBox="0 0 19 15" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" class="icon">
								<title>icon/arrow/dark</title>
								<g id="icon/arrow/dark" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
									<g id="icon/arrow-right" class="icon__fill" fill-rule="nonzero">
										<path d="M10.0742697,14.52 C10.3189888,13.8470225 11.0531461,11.7873034 11.3998315,10.9511798 C9.97230337,10.6044944 6.07719101,9.52365169 3.69117978,8.97303371 L3.69117978,8.78949438 C4.99634831,8.8302809 7.81061798,8.91185393 9.89073034,8.91185393 C12.3583146,8.91185393 15.8251685,8.97303371 18.0276404,9.05460674 C17.9926806,8.72248796 17.9876863,7.98583352 17.9869728,7.48676352 L17.9869728,7.02568562 C17.9876863,6.51377322 17.9926806,5.77711878 18.0276404,5.445 C15.8251685,5.52657303 12.3583146,5.58775281 9.89073034,5.58775281 C7.81061798,5.58775281 4.99634831,5.66932584 3.69117978,5.71011236 L3.69117978,5.52657303 C6.07719101,4.99634831 9.97230337,3.91550562 11.3998315,3.56882022 C11.0531461,2.75308989 10.3189888,0.672977528 10.0742697,-1.24344979e-14 C7.7494382,1.46831461 1.83539326,4.79241573 -1.20792265e-13,5.56735955 C-1.20792265e-13,5.89365169 0.0203932584,6.7705618 0.0203932584,7.26 C0.0203932584,7.76983146 -1.20792265e-13,8.62634831 -1.20792265e-13,8.95264045 C1.85578652,9.72758427 7.7494382,13.0516854 10.0742697,14.52 Z" id="←" transform="translate(9.013820, 7.260000) scale(-1, 1) translate(-9.013820, -7.260000) "></path>
									</g>
								</g>
							</svg>
						</a>

					</div>

				</div>

			</div>

		</div>

		<div class="candidate-search__main">

			<search></search>

		</div>

	</div>

</template>

<script>
import Filters from './filters.vue'
import Search from './search.vue'

export default {
	components: {
		Filters,
		Search
	}
}
</script>
